'use strict';
import request from '@/utils/request';
class FileuploadpostService{
    static list(){
        return request({
            url:'/fileupload/getfiles',
            method:'get'
        })
    }
    static deletefile(query){
        return request({
            url:'/fileupload/deletefile',
            method:'delete',
            params:query
        })
    }
    static uploadfiles(data){
        return request({
            url:'/fileupload/uploadfile',
            method:'post',
            data
        })
    }
}

export default FileuploadpostService
